import React from 'react';
import { useTranslation } from 'react-i18next';
import Layout from '../components/Layout';
import Back1 from '../assets/images/back-home-1.webp';
import SEO from '../components/SEO';
import NosotrosPage from '../pages/NosotrosPage';

export const Nosotros = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language; // Detecta el idioma actual
  const isEnglish = currentLang.startsWith('en');

  const canonicalUrl = isEnglish
    ? "https://dynamicore.io/en/about-us"
    : "https://dynamicore.io/nosotros";

  const hreflang = [
    { url: "https://dynamicore.io/nosotros", lang: "es" },
    { url: "https://dynamicore.io/en/about-us", lang: "en-us" }
  ];

  return (
    <Layout backgroundimage={Back1} actionDemo={false}>
      <SEO
        title={t("Innovación y digitalización financiera")}
        description={t('Somos pioneros en innovación y soluciones financieras. Digitalizamos procesos con enfoque humano y tecnológico.')}
        works={[
          t('Core Financiero'),
          t('Fintech'),
          t('Onboarding digital'),
          t('Aprobación de crédito'),
          t('Gestión de cobranza'),
          t('Análisis de crédito'),
          t('Core Bancario'),
          t('Automatización de procesos'),
          t('Procesos digitales'),
          t('Producto financiero'),
          t('Servicios financieros'),
          t('Digitalización de procesos'),
          t('Software financiero'),
          t('Dispersión'),
          t('Reportes automatizados'),
          t('Corebanking'),
          t('Sector financiero'),
          t('SOFIPO'),
          t('SOFOM'),
          t('CNBV'),
          t('Condusef'),
          t('Servicios financieros digitales'),
          t('Plataforma financiera'),
        ]}
        bolImage={false}
        ogImage={`dynamicore-preview.png`}
        twitterImage={`dynamicore-preview.png`}
        canonicalUrl={canonicalUrl}
        hreflang={hreflang}
      />
      <NosotrosPage />
    </Layout>
  );
};
